module.exports = __webpack_public_path__ + "img/ao.ea04172c.svg";